import { render } from "./NodeInfrastructureOverview.vue?vue&type=template&id=33351828&scoped=true&ts=true"
import script from "./NodeInfrastructureOverview.vue?vue&type=script&lang=ts"
export * from "./NodeInfrastructureOverview.vue?vue&type=script&lang=ts"

import "./NodeInfrastructureOverview.vue?vue&type=style&index=0&id=33351828&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33351828"]])

export default __exports__